// avoid errors creating constant instead of string, to catch errors 

export const CHANGE_SEARCH_FIELD = 'CHANGE_SEARCH_FIELD';

// Request for async actions in order to work with the API

export const REQUEST_ROBOTS_PENDING = 'REQUEST_ROBOTS_PENDING';
export const REQUEST_ROBOTS_SUCCESS = 'REQUEST_ROBOTS_SUCCESS';
export const REQUEST_ROBOTS_FAILED = 'REQUEST_ROBOTS_FAILED';

